import axiosWithAuth from '../utils/axiosWithAuth';
import axios from 'axios';
import { getApiEndpoint } from '../utils/apiConfig';

export const dependentMaterialService = {
  // Get all dependent materials (public endpoint)
  getAllDependentMaterials: async () => {
    try {
      const response = await axios.get(getApiEndpoint('dependent-materials/public'));
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching dependent materials:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch dependent materials'
      };
    }
  },

  // Get all dependent materials (authenticated)
  getAllDependentMaterialsAuth: async () => {
    try {
      const response = await axiosWithAuth().get(getApiEndpoint('dependent-materials'));
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching dependent materials:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch dependent materials'
      };
    }
  },

  // Get dependent material by ID
  getDependentMaterialById: async (id) => {
    try {
      const response = await axiosWithAuth().get(getApiEndpoint(`dependent-materials/${id}`));
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching dependent material:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch dependent material'
      };
    }
  },

  // Get dependent materials by material ID
  getDependentMaterialsByMaterial: async (materialId) => {
    try {
      const response = await axios.get(getApiEndpoint(`dependent-materials/material/${materialId}`));
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching dependent materials by material:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch dependent materials'
      };
    }
  },

  // Add new dependent material (admin only)
  addDependentMaterial: async (materialData) => {
    try {
      const response = await axiosWithAuth().post(getApiEndpoint('dependent-materials'), materialData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error adding dependent material:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to add dependent material'
      };
    }
  },

  // Update dependent material (admin only)
  updateDependentMaterial: async (id, materialData) => {
    try {
      const response = await axiosWithAuth().put(getApiEndpoint(`dependent-materials/${id}`), materialData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error updating dependent material:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update dependent material'
      };
    }
  },

  // Delete dependent material (admin only)
  deleteDependentMaterial: async (id) => {
    try {
      await axiosWithAuth().delete(getApiEndpoint(`dependent-materials/${id}`));
      return {
        success: true
      };
    } catch (error) {
      console.error('Error deleting dependent material:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to delete dependent material'
      };
    }
  }
};

export default dependentMaterialService; 